import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

const styles = {
  default: {
    fontFamily: '"Open Sans", sans-serif',
    fontWeight: 600,
    fontSize: 48 * 0.65,
    color: '#565759',
  },
  secondary: {
    fontFamily: '"Open Sans", sans-serif',
    fontWeight: 400,
    fontSize: 38 * 0.65,
    color: '#565759',
    borderLeft: '1px solid #979797',
    paddingLeft: 25 * 0.65,
  },
}

const OnboardingStepTitle = ({ classes, children, className, secondary }) => (
  <div
    className={classNames(className, {
      [classes.default]: !secondary,
      [classes.secondary]: secondary
    })}
  >
    { children }
  </div>
)

OnboardingStepTitle.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.any,
  secondary: PropTypes.bool,
  className: PropTypes.any,
}

export default withStyles(styles)(OnboardingStepTitle)
